<template>
  <div class="trending-authors-list">
    <AuthorInfo
      v-for="author in authors"
      :key="author.id"
      :author="author"
      :status="status"
      class="mb-4"
    />
  </div>
</template>

<script>
import AuthorInfo from "@/templates/author/AuthorInfo.vue";

export default {
  name: "TrendingAuthorsList",
  props: {
    authors: Array,
    status: String,
  },
  components: {
    AuthorInfo,
  },
};
</script>

<style>
.trending-authors-list .author-desc,
.trending-authors-list .follow-numbers,
.trending-authors-list .user-social-links {
  display: none;
}

.trending-authors-list .author-info {
  @apply flex flex-wrap gap-2 md:flex-nowrap items-center mb-8;
}
.trending-authors-list .author-name {
  @apply font-bold text-lg break-all;
}

.trending-authors-list .author-avatar {
  @apply w-16 h-16;
}

.trending-authors-list .author-info-desc {
  @apply -mt-2;
}

.trending-authors-list .author-desc {
  @apply hidden;
}
.trending-authors-list .author-avatar-parent {
  @apply w-full md:w-auto mr-4;
}

.trending-authors-list .author-buttons {
  max-width: 7rem;
  @apply grid-cols-1;
}

.trending-authors-list .author-buttons > button.outlined-button:nth-child(2) {
  @apply hidden;
}
</style>
